import * as stateNames from '../../constants/states'
import createThunkReducer from '../../utils/createThunkReducer'
import * as actionTypes from '../../constants/actionTypes'

export default {
  [stateNames.DEBTS_LIST]: createThunkReducer(actionTypes.DEBTS_LIST),
  [stateNames.REPORT_STATS_LIST]: createThunkReducer(actionTypes.REPORT_STATS_LIST),
}
